var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',_vm._g(_vm._b({style:(_vm.btnStyle),attrs:{"text-color":_vm.outlineColor}},'BaseButton',_vm.allPropsAndAttrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" Click Here ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }